import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelDetails } from 'src/app/common/interfaces/home/side-panel-details.interface';
import { Router } from '@angular/router';
import { DiscrepanciesComponent } from './discrepancies/discrepancies.component';
import { SidePanelFilterComponent } from './side-panel-filter/side-panel-filter.component';
import { SidePanelTableDataComponent } from './side-panel-table-data/side-panel-table-data.component';
import { MDSignatureComponent } from "./mdsignature/mdsignature.component";

@Component({
  selector: 'app-side-panel',
  standalone: true,
  imports: [
    CommonModule,
    DiscrepanciesComponent,
    SidePanelFilterComponent,
    SidePanelTableDataComponent,
    MDSignatureComponent
],
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  @Input() panelDetails!: SidePanelDetails;
  @Output() closed = new EventEmitter<boolean>();
  showFilters: boolean = false;
  showInfoNotes: boolean = false;

  // Panels with four or more columns don't fit the default width without truncating.
  get isWidePanel(): boolean {
    return Object.keys(this.panelDetails?.headerSection ?? {}).length >= 4;
  }

  // Per-reason row counts shown above the table; empty (hidden) for panels whose rows
  // carry no errorReason. Insertion order follows the API's reason-priority order.
  get reasonCounts(): { label: string; count: number }[] {
    const counts = new Map<string, number>();
    for (const row of this.panelDetails?.panelDetails ?? []) {
      if (row.errorReason) {
        counts.set(row.errorReason, (counts.get(row.errorReason) ?? 0) + 1);
      }
    }
    return Array.from(counts, ([label, count]) => ({ label, count }));
  }

  constructor(private router: Router) {}
  
  navigate(route: string) {
    this.router.navigateByUrl(route);
  }
  
  isShowFilters(){
    this.showFilters = !this.showFilters;
  }

  toggleInfoNotes(){
    this.showInfoNotes = !this.showInfoNotes;
  }
}
